<template>
    <div class="page-wrapper page" :class="showRoute">
        <div class="space-helper"></div>

        <div>
            <div class="page-grid-fix background-img top-blurb"
                style="background-image: linear-gradient(rgba(0, 0, 0, 0.527), rgba(0, 0, 0, 0.5)), url(uploads/MagazinesBanner.jpg);">
                <article class="grid-container columns-two transparent">
                    <section class="section1 transparent">
                        <div>
                            <h1>In The Press</h1>
                            <div>
                                <p>Discover the latest news, updates, and media resources about Ninety from the world's press.</p>
                                <!-- <p>Embark on a journey of elegance and sophistication through our featured press articles.</p> -->
                            </div>
                        </div>
                    </section>
                    <section class="section2 transparent">
                        <div>
                            <button type="submit"><a href="/contact" class="">Contact</a></button>
                        </div>
                    </section>
                </article>
            </div>
        </div>

        <div>
            <div class="page-grid-wrapper">
                <div class="page-grid-fix"></div>
            </div>
        
            <div v-for="(magazine, index) in magazines" :key="magazines.id" class="page-grid-wrapper">
                <div class="page-grid-fix">
                    <article class="grid-container columns-two showRoute standardBlurb evenBlurb" style="border-bottom: 1px solid #464646; padding-bottom: 75px;">
                        <section class="section1" style="display: grid;align-items: baseline;">
                            <div style="height:auto; width:100%; text-align: center;">
                                <div style="margin: 0px auto; height: 100%; width: 300px; background-color: #fcf1e6; display: grid; align-items: center; overflow: hidden;"><img style="width: 100%; " :src="'/' + magazine.articles_screenshot">
                                </div>
                            </div>
                        </section>
                        <section class="section2" style=" grid-template-columns: 75px 1fr; padding: 0 0 0 75px;">

                            <div style="width: 75px; height: 75px; align-self: normal;"><img style="width: 75px; " :src="'/' + magazine.publishers_logo"></div>
                            
                            <div style="text-align: left; padding-left: 45px;">
                                <h3 style="position: relative; top: -14px;">{{ magazine.title }}</h3>
                                <div class="meta" style="position: relative; top: -14px;">
                                    <span style="display: block; text-align: left; margin: 0; height: auto;"><em style="text-transform: lowercase; font-size: 0.8em; ">Published in</em> {{ magazine.publisher }}</span>
                                    <span style="display: inline-block; text-align: left; margin: 0; text-transform: capitalize; font-size: 0.8em; color: grey;">{{ formatDate(magazine.date) }}</span>
                                   
                                </div>
                                <div style="max-width: 350px; ">
                                    <p>{{ magazine.excerpt }}</p>
                                    <div class="meta" style="text-align: left;">
                                        <em style="text-transform: uppercase; font-size: 0.6em; color: #4a4a4a;">
                                            <a v-if="magazine.articles_link" style="color: #ae9248; text-align: left;" :href="magazine.articles_link">Link to article</a><div style="display: inline;" v-if="magazine.articles_link && magazine.article_download">&ensp;&ensp;|&ensp;&ensp;</div>
                                            <a v-if="magazine.article_download" style="color: #ae9248; text-align: left;" :href="magazine.article_download">Download</a><div style="display: inline;" v-if="magazine.article_download_translation">&ensp;&ensp;|&ensp;&ensp;</div>
                                            <a v-if="magazine.article_download_translation" style="color: #ae9248; text-align: left;" :href="magazine.article_download_translation">Translation</a>
                                        </em>
                                    </div> 
                                </div>
                            </div>

                        </section>
                    </article>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "Press",
  data() {
    return {
      magazines: [],
      showRoute: {
               showRoute : this.$route.name
           },
    };
  },
//   filters: {
//     formatDate: function (value) {
//         if (!value) return ''
//         const date = new Date(value)
//         const monthNames = ["January", "February", "March", "April", "May", "June",
//         "July", "August", "September", "October", "November", "December"
//         ];
//         const day = date.getDate();
//         const monthIndex = date.getMonth();
//         const year = date.getFullYear();

//         return monthNames[monthIndex] + ' ' + day + ', ' + year;
//     }
//     },
 methods: {
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();

      return `${monthNames[monthIndex]} ${day}, ${year}`;
    }
  },
  watch: {
        '$route.name': function () {
          this.showRoute = this.$route.name;
        },    
    },
    created() {
        this.showRoute = this.$route.name
       
    },
    mounted() {
    this.$axios.get("/api/magazines").then((response) => {
        this.magazines = response.data.sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
        });
        this.$emit("route-data-ready"); // tells App.vue to hide loader
    });
    },
}
</script>
